export default "__VITE_ASSET__668c0129__"